import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
const links = [{
  to: '/work',
  label: 'Work'
}, {
  to: '/about',
  label: 'About'
}, {
  to: '/contact',
  label: 'Contact'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [pathname]);
  return <header className="sticky top-0 z-50 border-b border-line bg-ink/90 backdrop-blur-sm" data-id="element-24" data-mp="2rlm931z3vmcl">
      <div className="mx-auto flex max-w-page items-center justify-between px-6 py-4 md:px-10" data-id="element-25" data-mp="2wjntbq89prpn">
        <Link to="/" aria-label="Breezy Experiential — home" className="block" data-id="element-26" data-mp="31cgyugbk942s">
          <img src="https://cdn.magicpatterns.com/uploads/javFhNUJ7GVHe95isNt3eZ/Breezy-logo-stacked-lime.png" alt="Breezy Experiential" className="h-9 w-auto transition-opacity hover:opacity-70 md:h-10" data-id="element-27" data-mp="36a0b5aop76s3" />
        </Link>

        <nav aria-label="Primary" className="hidden items-center gap-10 md:flex" data-id="element-28" data-mp="2wkkwt7hste14">
          {links.map(link => <NavLink key={link.to} to={link.to} className={({
          isActive
        }) => `text-[0.7rem] uppercase tracking-micro transition-colors ${isActive ? 'text-sage' : 'text-cream/65 hover:text-cream'}`} data-id="element-29" data-mp="2rl88eiba3ywf">
              {link.label}
            </NavLink>)}
          <Link to="/contact" className="rounded-full bg-lilac px-5 py-2.5 text-[0.65rem] uppercase tracking-micro text-ink transition-colors hover:bg-sage" data-id="element-30" data-mp="3acj031otwfpd">
            Start a project
          </Link>
        </nav>

        <button type="button" onClick={() => setOpen(value => !value)} aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} className="-mr-2 p-2 text-cream md:hidden" data-id="element-31" data-mp="30lworjo5abch">
          {open ? <XIcon size={20} data-id="element-32" data-mp="1rdtcbws5s14w" /> : <MenuIcon size={20} data-id="element-33" data-mp="1remeekg6a2gp" />}
        </button>
      </div>

      {open && <nav aria-label="Mobile" className="border-t border-line bg-ink px-6 py-2 md:hidden" data-id="element-34" data-mp="1wd62aqebtobp">
          {links.map(link => <NavLink key={link.to} to={link.to} className={({
        isActive
      }) => `block border-b border-line py-3.5 font-display text-2xl font-semibold uppercase last:border-0 ${isActive ? 'text-sage' : 'text-cream'}`} data-id="element-35" data-mp="1hlnq73ol8dxm">
              {link.label}
            </NavLink>)}
        </nav>}
    </header>;
}